import React from 'react'
import {Link} from 'gatsby'
import {format} from 'date-fns'
import LazyLoad from 'react-lazyload'

// Components
import LatestBL from './LatestBlogList.styled'

// Constants
import {BLOG_DETAILS} from '~/constants/pages.constant'

// Utils
import {pathReplacer, enhancedGet} from '~/utils'

const LatestBlogListComponent = (props) => {
  const {
    list,
  } = props

  return (
    <LatestBL>
      <LatestBL.Title>Bài viết mới</LatestBL.Title>

      <LatestBL.ItemsWrapper>
        {list.map((item) => {
          const {
            id,
            title,
            slug,
            thumbnail,
            createdAt,
          } = item

          const date = format(new Date(createdAt), 'dd/MM/yyyy')

          return (
            <LatestBL.Item
              key={id}
              as={Link}
              to={pathReplacer(BLOG_DETAILS, {slug})}
            >
              <LatestBL.ItemThumbnail>
                <LazyLoad
                  className='img-container'
                  once
                  offset={250}
                >
                  <img
                    alt={thumbnail.alt || title}
                    src={enhancedGet(thumbnail, 'url', '')}
                    srcSet={thumbnail.srcSet}
                    sizes={thumbnail.sizes}
                    className='img-cover-center'
                    style={{height: '100%'}}
                  />
                </LazyLoad>

                <noscript>
                  <div className='img-container'>
                    <img
                      alt={thumbnail.alt || title}
                      src={enhancedGet(thumbnail, 'url', '')}
                      srcSet={thumbnail.srcSet}
                      sizes={thumbnail.sizes}
                      className='img-cover-center'
                      style={{height: '100%'}}
                    />
                  </div>
                </noscript>
              </LatestBL.ItemThumbnail>

              <LatestBL.ItemRight>
                <LatestBL.ItemDate>{date}</LatestBL.ItemDate>

                <LatestBL.ItemTitle>{title}</LatestBL.ItemTitle>
              </LatestBL.ItemRight>
            </LatestBL.Item>
          )
        })}
      </LatestBL.ItemsWrapper>
    </LatestBL>
  )
}

export default LatestBlogListComponent
